import { CoreType } from "../../../core/Type";
import { TimeController } from "../../scene/utils/TimeController";
import { PolyEventsDispatcher, PolyEventName } from "../common/EventsDispatcher";
import { PROGRESS_RATIO } from "../common/Progress";
import { SceneJsonImporter } from "../json/import/Scene";
export class ScenePlayerImporter {
  constructor(options) {
    this.options = options;
    this._onLoadCompleteCalled = false;
    this._viewerMarkedAsReady = false;
    this._sceneMarkedAsReady = false;
  }
  static async loadSceneData(options) {
    const importer = new ScenePlayerImporter(options);
    const scene = await importer.loadScene();
    const viewer = importer._viewer;
    return { scene, viewer };
  }
  async _onLoadComplete(scene) {
    if (this._onLoadCompleteCalled == true) {
      return;
    }
    this._onLoadCompleteCalled = true;
    if (this._viewer) {
      this._markViewerAsReady(this._viewer);
    }
    await this._markSceneAsReady(scene);
  }
  _markViewerAsReady(viewer) {
    if (this._viewerMarkedAsReady) {
      return;
    }
    this._viewerMarkedAsReady = true;
    viewer.markAsReady();
  }
  async _markSceneAsReady(scene) {
    if (this._sceneMarkedAsReady) {
      return;
    }
    this._sceneMarkedAsReady = true;
    await scene.cookController.waitForCooksCompleted();
    scene.setFrame(TimeController.START_FRAME);
    if (this.options.autoPlay != false) {
      scene.play();
    }
    this._dispatchEvent(PolyEventName.SCENE_READY);
  }
  _onNodesCookProgress(nodesCookProgress, args) {
    const progressRatio = PROGRESS_RATIO.nodes;
    const onProgress = (_ratio, args2) => {
      var _a;
      const progress = progressRatio.start + progressRatio.mult * _ratio;
      if (this.options.onProgress) {
        this.options.onProgress(progress, args2);
      }
      PolyEventsDispatcher.dispatchProgressEvent(progress, (_a = this._scene) == null ? void 0 : _a.name());
    };
    onProgress(nodesCookProgress, args);
    if (nodesCookProgress >= 1) {
      this._onLoadComplete(args.scene);
    }
  }
  async _watchNodesProgress(scene) {
    scene.root().loadProgress.watchNodesProgress((nodesCookProgress, args) => {
      this._onNodesCookProgress(nodesCookProgress, args);
    });
  }
  async loadScene() {
    const createSceneAndWaitForCameraCreatorNode = () => {
      return new Promise(async (resolve) => {
        const configureScene = this.options.configureScene;
        const importer = new SceneJsonImporter(this.options.sceneData, {
          sceneName: this.options.sceneName,
          configureScene,
          nodeCookWatcher: (scene3) => {
            this._watchNodesProgress(scene3);
          }
        });
        const scene2 = importer.scene();
        this._onCameraCreatorNodeLoadedResolve = () => resolve(scene2);
        scene2.camerasController.onCameraObjectsUpdated(async () => {
          const camera = await scene2.camerasController.mainCamera({ findAnyCamera: false });
          if (camera) {
            if (this._onCameraCreatorNodeLoadedResolve) {
              this._onCameraCreatorNodeLoadedResolve();
            }
          }
        });
      });
    };
    this._scene = await createSceneAndWaitForCameraCreatorNode();
    const scene = this._scene;
    const createViewer = async () => {
      const domElement = this._domElement();
      let createViewer2 = false;
      if (this.options.createViewer != null) {
        createViewer2 = this.options.createViewer;
      }
      if (domElement || createViewer2) {
        this._viewer = await scene.camerasController.createMainViewer({
          autoRender: false
        });
        if (this._viewer) {
          if (domElement) {
            this._viewer.mount(domElement);
          }
          if (this._sceneMarkedAsReady == true) {
            this._markViewerAsReady(this._viewer);
          }
          this._dispatchEvent(PolyEventName.VIEWER_MOUNTED);
        }
      }
    };
    await createViewer();
    return scene;
  }
  _domElement() {
    const domElement = this.options.domElement;
    if (domElement) {
      if (CoreType.isString(domElement)) {
        const element = document.getElementById(domElement);
        if (element) {
          return element;
        }
      } else {
        return domElement;
      }
    }
  }
  _dispatchEvent(eventName) {
    const elements = [this._domElement(), document];
    const createEvent = (customEventName) => {
      return new CustomEvent(customEventName, {
        detail: {
          scene: this._scene,
          viewer: this._viewer
        }
      });
    };
    for (let element of elements) {
      if (element) {
        element.dispatchEvent(createEvent(eventName));
        if (this._scene) {
          element.dispatchEvent(createEvent(`${eventName}-${this._scene.name()}`));
        }
      }
    }
  }
}
